export const getExpressionOperatorOptions = i18n => [
  {
    key: 'EqualsTo',
    text: i18n.getString(_TL_('Equals to')),
    title: i18n.getString(_TL_('Equals to')),
    description: i18n.getString(_TL_('Only visits to this exact URL would be considered conversions. For example: If the web page URL you choose is https://www.contoso.com, a visit to https://www.contoso.com will count as a conversion.')),
    link: 'https://help.bingads.microsoft.com/#apex/3/en/56689/2',
    ariaLabel: i18n.getString(_TL_('Equals to')),
  },
  {
    key: 'BeginsWith',
    text: i18n.getString(_TL_('Begins with')),
    title: i18n.getString(_TL_('Begins with')),
    description: i18n.getString(_TL_('Visits to any web pages that contains the beginning of the URL you select would be considered a conversion. For example: If the web page URL you choose is www.contoso.com, www.contoso.com/home will count as a conversion.')),
    link: 'https://help.bingads.microsoft.com/#apex/3/en/56689/2',
    ariaLabel: i18n.getString(_TL_('Begins with')),
  },
  {
    key: 'Contains',
    text: i18n.getString(_TL_('Contains')),
    title: i18n.getString(_TL_('Contains')),
    description: i18n.getString(_TL_('Visits to any web pages that contain part of the text you input would be considered a conversion. For example: If the text you input is “confirmation,” visits to www.contoso.com/confirmation or www.adatum.com/confirmation will count as a conversion.')),
    link: 'https://help.bingads.microsoft.com/#apex/3/en/56689/2',
    ariaLabel: i18n.getString(_TL_('Contains')),
  },
  {
    key: 'RegularExpression',
    text: i18n.getString(_TL_('Regular expression')),
    title: i18n.getString(_TL_('Regular expression')),
    description: i18n.getString(_TL_('Customize your own rules using regular expressions.')),
    link: 'https://help.bingads.microsoft.com/#apex/3/en/56715/2',
    ariaLabel: i18n.getString(_TL_('Regular expression')),
  },
];

export const getValueOperatorOptions = i18n => [
  {
    key: 'EqualTo',
    text: i18n.getString(_TL_('Equals to')),
    title: i18n.getString(_TL_('Equals to')),
    ariaLabel: i18n.getString(_TL_('Equals to')),
  },
  {
    key: 'LessThan',
    text: i18n.getString(_TL_('Less than')),
    title: i18n.getString(_TL_('Less than')),
    ariaLabel: i18n.getString(_TL_('Less than')),
  },
  {
    key: 'GreaterThan',
    text: i18n.getString(_TL_('Greater than')),
    title: i18n.getString(_TL_('Greater than')),
    ariaLabel: i18n.getString(_TL_('Greater than')),
  },
];

export const getAppPlatformOptions = i18n => [
  {
    key: 'Windows Phone',
    text: i18n.getString(_TL_('Windows Phone')),
    placeholder: '12345678-9abc-1234-1',
    ariaLabel: i18n.getString(_TL_('Windows Phone')),
  },
  {
    key: 'Android',
    text: i18n.getString(_TL_('Android')),
    placeholder: 'com.example.app',
    ariaLabel: i18n.getString(_TL_('Android')),
  },
  {
    key: 'iOS',
    text: i18n.getString(_TL_('iOS')),
    placeholder: '123456789',
    ariaLabel: i18n.getString(_TL_('iOS')),
  },
  {
    key: 'Windows',
    text: i18n.getString(_TL_('Windows')),
    placeholder: '12345678-9abc-1234-1',
    ariaLabel: i18n.getString(_TL_('Windows')),
  },
];

export const getRevenueOptions = i18n => [
  {
    key: 'FixedValue',
    text: i18n.getString(_TL_('Each conversion action has the same value')),
    ariaLabel: i18n.getString(_TL_('Each conversion action has the same value')),
  },
  {
    key: 'VariantValue',
    text: i18n.getString(_TL_('Conversion action value may vary (for example, by purchase price)')),
    ariaLabel: i18n.getString(_TL_('Conversion action value may vary (for example, by purchase price)')),
  },
  {
    key: 'NoValue',
    text: i18n.getString(_TL_('Don\'t assign a value')),
    ariaLabel: i18n.getString(_TL_('Don\'t assign a value')),
  },
];

export const getBoostRevenueOptions = i18n => [
  {
    key: 'FixedValue',
    text: i18n.getString(_TL_('Each conversion action has the same value')),
    ariaLabel: i18n.getString(_TL_('Each conversion action has the same value')),
  },
];
